import styled from 'styled-components';

interface InfoIconProps {
  children: React.ReactNode;
  className?: string;
}

const InfoIcon = ({ children, className = '' }: InfoIconProps) => (
  <div className={className}>{children}</div>
);

const InfoIconStyled = styled(InfoIcon)`
  font-size: 0.75rem;
  line-height: 1.166666666666667;
  border-radius: 0.125rem;
  display: inline-flex;
  align-items: center;
  padding: 0.125rem;
  vertical-align: middle;

  &.info {
    color: ${({ theme }) => theme.primaryText};
    background-color: ${({ theme }) => theme.primaryBackground};
    transition:
      color 0.15s ease-in-out,
      background-color 0.15s ease-in-out;
    cursor: pointer;
    margin-left: 0.25rem;
    margin-right: 0.25rem;

    &:hover {
      color: ${({ theme }) => theme.primaryTextStrong};
      background-color: ${({ theme }) => theme.primaryAction};
    }

    svg {
      margin: 0;
    }
  }
`;

export default InfoIconStyled;
